import React from "react";
import { StateDispatchProps } from "../components/state-dispatch.props";
import { QqKeyInfoItemText } from "../model/qq-key-info-item.model";
import { Box } from "@mui/material";
import { ResTextTypography } from "./qq-typohraphy.controls";

export type QqResTextControlProps = StateDispatchProps & QqKeyInfoItemText;

export const QqResTextControl: React.FunctionComponent<QqResTextControlProps> =
  ({ text }) => {
    return (
      <Box>
        <ResTextTypography>{text}</ResTextTypography>
      </Box>
    );
  };
